module.exports = "<div class=input-field> <icon v-if=icon :class=iconClasses :value=icon></icon> <textarea v-el:text-area :id=id :class=textareaClasses :length=length>{{value}}</textarea> <label :for=id :class=\"value ? 'active' : ''\" :data-error=errorMessage :data-success=successMessage>{{label}}<slot></slot></label> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/forms/text-area.vue
 ** module id = 272
 ** module chunks = 0
 **/